import React from 'react';
import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import ClassesTable from '../../components/classes/ClassesTable';

const ClassesArchive = () => (<WrapperSection><GlobalBreadcrumbs /><ClassesTable isArchive /></WrapperSection>);
export default ClassesArchive;
